import React from "react"
import CustomPageHeader from "../../fragments/CustomPageHeader"

export default function GLAccount({ children }) {
  return (
    <div>
      <CustomPageHeader icon='sitemap' text='GL accounts' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/GLAccounts/index.js